// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fMTd6ZrZr2YDYhEbuztg{justify-content:center;align-items:center;height:108px;display:flex}.fMTd6ZrZr2YDYhEbuztg .izlIirizXEcTEFVf7BHq{width:auto;height:28px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoWrap": `fMTd6ZrZr2YDYhEbuztg`,
	"logo": `izlIirizXEcTEFVf7BHq`
};
export default ___CSS_LOADER_EXPORT___;
